// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".desc[data-v-39d4758a] {\n  border-radius: 30px;\n  width: 90%;\n  background-color: #F2F2F2;\n  margin: 16px auto;\n  background: #d1d2fe;\n  padding: 15px 30px;\n  font-size: 12px;\n  color: #000;\n  line-height: 1.4;\n}", ""]);
// Exports
module.exports = exports;
